export default function() {
    document.querySelectorAll('.tab-button').forEach(function(tab_button_element) {
        tab_button_element.addEventListener('click', function(event) {
        	event.preventDefault();
            event.stopImmediatePropagation();

            if(this.classList.contains('-alone')) {
                document.querySelectorAll('.tab').forEach( tab => tab.classList.remove('-active'));
            }

            tab_button_element.querySelectorAll('svg').forEach( icon => icon.classList.toggle('rotate-0'));
            tab_button_element.querySelectorAll('svg').forEach( icon => icon.classList.toggle('rotate-180'));

            this.closest('.tab').classList.toggle('-active');
        });
    });
}
